import { flatten } from "flat";

import Tokens from "./semantic";
import { ColorToken } from "./types";

export const COLOR_TOKENS = Object.keys(flatten(Tokens)) as ColorToken[];
